/**
 * Releases references to a canvas and its context to help GC.
 * Setting width/height to 0 frees the underlying bitmap memory.
 */
export function cleanupCanvas(canvas: HTMLCanvasElement): void {
  const ctx = canvas.getContext('2d')
  if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height)
  canvas.width = 0
  canvas.height = 0
}

/**
 * Revokes an object URL if it exists.
 */
export function revokeObjectURL(url: string | null): void {
  if (url) URL.revokeObjectURL(url)
}
